import { cityByAirport } from '@voll-intelligence/domain';
import {
  FlightSummaryPill,
  type SummaryPillTarget,
  type FlightExplorerRequest,
} from '@voll-intelligence/intelligence-ui-kit';
import { useGenUiI18n } from '../../../shared/ui/i18n.js';

/**
 * A pill do PEDIDO DO EXPLORER (`bandAsPill`) — a `FlightSummaryPill` do kit,
 * a MESMA da bancada do web-chat, com as copies do genui-kit (abas do planner).
 * Sem viajante: o request do explorer só carrega `policyTravelerId`, nunca
 * nomes — quem conhece a lista é a pill do shell. A lupa (`onSearch`) é o
 * "Tentar de novo" da coluna sem abrir o planner: re-busca a fase corrente com o
 * pedido tal como está.
 */
export function ExplorerPill({
  request,
  hidden,
  readOnly,
  onExpand,
  onSearch,
}: Readonly<{
  request: FlightExplorerRequest;
  hidden: boolean;
  readOnly: boolean;
  onExpand: (target: SummaryPillTarget) => void;
  /** Lupa da barra: re-busca a fase corrente (`io.retry`) sem passar pelo
   *  planner. Ausente ⇒ sem botão. */
  onSearch?: () => void;
}>) {
  const { t, locale } = useGenUiI18n();
  return (
    <FlightSummaryPill
      summary={{
        tripType: request.mode,
        legs: request.legs,
        ...(request.returnDate ? { returnDate: request.returnDate } : {}),
      }}
      copy={{
        aria: t('flightExplorer.pillAria'),
        tripType: {
          one_way: t('flightPlanner.tripType.oneWay'),
          round_trip: t('flightPlanner.tripType.roundTrip'),
          multi_leg: t('flightPlanner.tripType.multiLeg'),
        },
        legs: (count) =>
          t(count === 1 ? 'flightExplorer.pill.legs_one' : 'flightExplorer.pill.legs_other', {
            count,
          }),
      }}
      locale={locale}
      cityOf={cityByAirport}
      hidden={hidden}
      readOnly={readOnly}
      onExpand={onExpand}
      {...(onSearch ? { search: { onSearch, label: t('flightExplorer.searchAgain') } } : {})}
    />
  );
}
